import { ReactNode, useContext } from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';

import { ContentBox } from 'components/ContentBox';
import { CompanyContext } from 'index';
import { CompanyLogo } from 'components/CompanyLogo';
import {
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import { ReactComponent as SelectedIndicatorIcon } from 'assets/images/selected-indicator.svg';
import { ReactComponent as CreateIcon } from 'assets/images/create.svg';
import * as _paths from 'routes/paths';
import { DIALOG_TYPES, useGlobalDialogContext } from '../dialog/GlobalDialog';
import styles from './styles.module.scss';
import { useManager } from '../../../../../contexts/access/ManagerContext/useManager';

export const paths = _paths;

type ListItemCustomProps = {
  title: string;
  disabled?: boolean;
  selected?: boolean;
  action?: ReactNode;
  icon?: ReactNode;
  path?: string;
};

const ListItemCustom = ({
  title,
  selected = false,
  disabled = false,
  action,
  path = '/',
}: ListItemCustomProps) => {
  const navigate = useNavigate();
  return (
    <ListItem
      disablePadding
      classes={{
        root: styles.listItem,
      }}
    >
      <ListItemButton
        selected={selected}
        disabled={disabled}
        classes={{
          root: styles.listItemButton,
          selected: styles.listItemButtonSelected,
        }}
      >
        <SelectedIndicatorIcon />
        <ListItemText
          primary={title}
          classes={{
            root: styles.listText,
          }}
          onClick={() => navigate(path)}
        />
        {action}
      </ListItemButton>
    </ListItem>
  );
};

export const Menu = () => {
  const { showDialog } = useGlobalDialogContext();
  const company = useContext(CompanyContext);
  const location = useLocation();
  const { isReadOnly } = useManager();

  return (
    <ContentBox className={styles.root}>
      <CompanyLogo
        src={company.logo}
        responsive={true}
        className={styles.logo}
      />
      <List className={styles.list}>
        {!isReadOnly && (
          <ListItemCustom
            title="Requests"
            selected={!!matchPath(paths.DashboardPage, location.pathname)}
            path={paths.DashboardPage}
            action={
              <IconButton
                onClick={() =>
                  showDialog(DIALOG_TYPES.CREATE_REQUEST_DIALOG, {})
                }
              >
                <CreateIcon />
              </IconButton>
            }
          />
        )}
        <ListItemCustom
          title="Drivers"
          selected={
            !!matchPath(`${paths.DashboardDriversPage}/*`, location.pathname)
          }
          path={paths.DashboardDriversPage}
        />
        <ListItemCustom
          title="Logout"
          selected={false}
          path={paths.LogoutPage}
        />
      </List>
    </ContentBox>
  );
};
